module.exports = __webpack_public_path__ + "img/1-3-p4.a529c3c8.svg";